<i
  class="fa fa-folder"
  [class.root-node]="nodeType === 'hierarchy'"
  [class.campus-node]="nodeType === 'campus'"
  [class.region-node]="nodeType === 'region'"
></i>
